
// DEFINE ACTIONS TYPE

export const FETCH_USERS_REQUEST= 'FETCH_USERS_REQUEST'
export const FETCH_USERS_SUCESS= 'FETCH_USERS_SUCESS'
export const FETCH_USERS_FAILURE= 'FETCH_USERS_FAILURE'
export const DELETE_USER= 'DELETE_USER'
export const EDIT_USER= 'EDIT_USER'
export const ADD_USER= 'ADD_USER'

